var exports = {
  "Finding": "Finding__sx7cs-",
  "header": "header__Ks5ZGf",
  "toggleButton": "toggleButton__7proxO",
  "headerContent": "headerContent__tW4yJ8",
  "expandedContent": "expandedContent__LOUUQT",
  "section": "section__H9qcKJ",
  "sectionTitle": "sectionTitle__Oq8Hy5",
  "diffPreview": "diffPreview__71_eMd",
  "diffEntryHeader": "diffEntryHeader__BNGiPa",
  "automatedReviewDiff": "automatedReviewDiff__SvDi6n",
  "metaItem": "metaItem__ZmQknw",
  "sourceItem": "sourceItem__4cN8in",
  "taskStatusSection": "taskStatusSection__gAFT5c",
  "taskStatusCard": "taskStatusCard__Iqg_61",
  "taskStatusContent": "taskStatusContent__gDkpWy",
};

__webpack_require__.r(module.exports = exports);
